// ===============================================================
// ⭐ ConfirmDeletePopup.js — Confirm delete popup (i18n)
// ===============================================================

import React from "react";
import "./ConfirmDeletePopup.css";
import { useTranslation } from "react-i18next";

function ConfirmDeletePopup({ onCancel, onConfirm }) {
  const { t } = useTranslation();

  return (
    <div className="popup-overlay">
      <div className="popup-box">

        <h2 className="popup-title">
          {t("confirm_delete_account")}
        </h2>

        <p className="popup-message" style={{ whiteSpace: "pre-line" }}>
          {t("confirm_delete_account_desc")}
        </p>

        <div className="popup-buttons">
          <button className="popup-cancel" onClick={onCancel}>
            {t("cancel")}
          </button>

          <button className="popup-delete" onClick={onConfirm}>
            {t("delete_account")}
          </button>
        </div>

      </div>
    </div>
  );
}

export default ConfirmDeletePopup;
